import {defineStore} from 'pinia';

export const useStaticStore = defineStore('static', {
  state: () =>
    ({
      galleryList: [
        {
          name: 'DWFI hotel',
          desc: ['dwfiHotelRoom', 'dfLauncher', 'konstantinVlasov'],
          images: [
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/DWFI-renders-1.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/DWFI-renders-2.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/DWFI-renders-3.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/DWFI-renders-4.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/DWFI-renders-5.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/DWFI-renders-6.webp`,
          ],
          video: [
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_DWFI_Video3.mp4`,
            ],
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_DWFI_Video2.mp4`,
            ],
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_DWFI_Video1.mp4`,
            ],
          ],
          videoMobile: [
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_DWFI_Video3_mobile.mp4`,
            ],
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_DWFI_Video2_mobile.mp4`,
            ],
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_DWFI_Video1_mobile.mp4`,
            ],
          ],
          poster: [
            {
              videoSrc: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_DWFI_Video3.mp4`,
              value: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/images/G_DWFI_Video3-poster.webp`,
            },
            {
              videoSrc: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_DWFI_Video2.mp4`,
              value: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/images/G_DWFI_Video2-poster.webp`,
            },
            {
              videoSrc: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_DWFI_Video1.mp4`,
              value: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/images/G_DWFI_Video1-poster.webp`,
            },
          ],
          tour: '/tours/Tour_from_24.08.2023_14-12-16-512/index.htm?n=2',
        },
        {
          name: 'Stockholm',
          desc: [
            'futuristicOpenSpace',
            'launcherStockholm',
            'konstantinVlasov',
          ],
          images: [
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/Stockholm-renders-1.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/Stockholm-renders-2.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/Stockholm-renders-3.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/Stockholm-renders-4.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/Stockholm-renders-5.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/Stockholm-renders-6.webp`,
          ],
          video: [
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_Stockholm_1.mp4`,
            ],
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_Stockholm_2.mp4`,
            ],
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_Stockholm_3.mp4`,
            ],
          ],
          videoMobile: [
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_Stockholm_1_mobile.mp4`,
            ],
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_Stockholm_2_mobile.mp4`,
            ],
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_Stockholm_3_mobile.mp4`,
            ],
          ],
          poster: [
            {
              videoSrc: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_Stockholm_1.mp4`,
              value: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/images/G_Stockholm_1-poster.webp`,
            },
            {
              videoSrc: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_Stockholm_2.mp4`,
              value: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/images/G_Stockholm_2-poster.webp`,
            },
            {
              videoSrc: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_Stockholm_3.mp4`,
              value: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/images/G_Stockholm_3-poster.webp`,
            },
          ],
          tour: '/tours/Tour_from_24.05.2023_17-51-15-366/index.htm?n=2',
        },
        {
          name: 'Minotti Goodman',
          desc: ['minottiShowroom', 'goodman', 'developedDreamFlat'],
          images: [
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/Minotty-renders-1.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/Minotty-renders-2.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/Minotty-renders-3.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/Minotty-renders-4.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/Minotty-renders-5.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/Minotty-renders-6.webp`,
          ],
          video: [
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_Minotti_Video1.mp4`,
            ],
          ],
          videoMobile: [
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_Minotti_Video1_mobile.mp4`,
            ],
          ],
          poster: [
            {
              videoSrc: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_Minotti_Video1.mp4`,
              value: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/images/G_Minotti_Video1-poster.webp`,
            },
          ],
          tour: '/tours/Tour_from_24.08.2023_15-10-22-709/index.htm?n=1',
        },
        {
          name: 'Ogogo Forest',
          desc: ['forestFairytale', 'forest', 'elizavetaVolodina'],
          images: [
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/Forest-renders-1.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/Forest-renders-2.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/Forest-renders-3.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/Forest-renders-4.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/Forest-renders-5.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/Forest-renders-6.webp`,
          ],
          video: [
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_Fores_Video1.mp4`,
            ],
          ],
          videoMobile: [
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_Fores_Video1_mobile.mp4`,
            ],
          ],
          poster: [
            {
              videoSrc: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/G_Fores_Video1.mp4`,
              value: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/images/G_Fores_Video1-poster.webp`,
            },
          ],
          tour: '/tours/Tour_from_17.03.2023_12-05-58-572/index.htm?n=1',
        },
      ],
      galleryRealtList: [
        {
          name: 'Отделка от застройщика',
          desc: ['dwfiHotelRoom', 'dfLauncher', 'konstantinVlasov'],
          images: [
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/realty-developer-opt-image1.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/realty-developer-opt-image2.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/realty-developer-opt-image3.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/realty-developer-opt-image4.webp`,
          ],
          video: [
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_developer_video1.mp4`,
            ],
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_developer_video2.mp4`,
            ],
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_developer_video3.mp4`,
            ],
          ],
          videoMobile: [
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_developer_video1_mobile.mp4`,
            ],
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_developer_video2_mobile.mp4`,
            ],
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_developer_video3_mobile.mp4`,
            ],
          ],
          poster: [
            {
              videoSrc: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_developer_video1.mp4`,
              value: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/images/R_developer_video1-poster.webp`,
            },
            {
              videoSrc: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_developer_video2.mp4`,
              value: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/images/R_developer_video2-poster.webp`,
            },
            {
              videoSrc: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_developer_video3.mp4`,
              value: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/images/R_developer_video3-poster.webp`,
            },
          ],
          tour: '/tours/Tour_from_18.12.2023_17-13-18-303/index.htm?n=3',
        },
        {
          name: 'S.E.A Design Studio',
          desc: [
            'futuristicOpenSpace',
            'launcherStockholm',
            'konstantinVlasov',
          ],
          images: [
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/realty-sea-design-image1.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/realty-sea-design-image2.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/realty-sea-design-image3.webp`,
            `${
              useRuntimeConfig().public.vueAppStaticUrl
            }/images/realty-sea-design-image4.webp`,
          ],
          video: [
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_sea-design_video1.mp4`,
            ],
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_sea-design_video2.mp4`,
            ],
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_sea-design_video3.mp4`,
            ],
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_sea-design_video4.mp4`,
            ],
          ],
          videoMobile: [
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_sea-design_video1_mobile.mp4`,
            ],
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_sea-design_video2_mobile.mp4`,
            ],
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_sea-design_video3_mobile.mp4`,
            ],
            [
              `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_sea-design_video4_mobile.mp4`,
            ],
          ],
          poster: [
            {
              videoSrc: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_sea-design_video1.mp4`,
              value: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/images/R_sea-design_video1-poster.webp`,
            },
            {
              videoSrc: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_sea-design_video2.mp4`,
              value: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/images/R_sea-design_video2-poster.webp`,
            },
            {
              videoSrc: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_sea-design_video3.mp4`,
              value: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/images/R_sea-design_video3-poster.webp`,
            },
            {
              videoSrc: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/video/R_sea-design_video4.mp4`,
              value: `${
                useRuntimeConfig().public.vueAppStaticUrl
              }/images/R_sea-design_video4-poster.webp`,
            },
          ],
          tour: '/tours/Tour_from_18.12.2023_18-19-47-112/index.htm?n=3',
        },
      ],
      listArticles: [
        {
          id: 1,
          icon: `${
            useRuntimeConfig().public.vueAppStaticUrl
          }/images/svg/info.svg`,
          title: 'hsDreamFlatTitle',
          linkName: 'about-dream-flat',
          subtitle: 'hcDreamflatDesc',
          articlesTitle: [
            {
              id: 1,
              title: 'aboutDreamFlat',
              articles: [
                {
                  id: 1,
                  title: 'howWhyUse',
                  text: [
                    'userFriendlyWind10ConstructorDesign',
                    'uniqueInteriorExtensiveLibrary',
                    'uploadOwnModels',
                    'freemium',
                    'comprehensiveFunctionality',
                  ],
                },
                {
                  id: 2,
                  title: 'dreamFlatFunctionality',
                  text: [
                    'preInstalledModels',
                    'libraryExpanding',
                    'finishing',
                    'finishing100Options',
                    'uploadUrModels',
                    'enterpriseSubscribers',
                    'customizableModels',
                    'customizeModels',
                    'primitivesFive',
                    'offersPrimitives',
                    'geometricShapes',
                    'primitivesDesigner',
                  ],
                },
                {
                  id: 3,
                  title: 'finResult',
                  text: [
                    'fiveWaysShowing',
                    'options5Presenting',
                    'useRendersForAdding',
                    'showInterior',
                    'viewerApartment',
                  ],
                },
                {
                  id: 4,
                  title: 'uEngine5Graphics',
                  text: [
                    'dreamFlatUsesLatestUnrealEngine',
                    'rayTracingRenderingTake',
                  ],
                },
              ],
            },
            {
              id: 2,
              title: 'dreamFlatInstallRun',
              articles: [
                {
                  id: 1,
                  title: 'systemRequirement',
                  text: [
                    'offerMinimum',
                    'offerOS',
                    'processoroffer',
                    'ramShort',
                    'videocard',
                    'diskSpaceOffer',
                    'offerRecomended',
                    'offerSystemReq',
                  ],
                },
                {
                  id: 2,
                  title: 'installingRunning',
                  text: [
                    'startedDownload',
                    'clickButtonBelow',
                    'downloadWindow',
                    'directX12',
                    'visualC',
                    'librariesInstalled',
                    'openDreamFlatUrComp',
                  ],
                },
              ],
            },
            {
              id: 3,
              title: 'subscriptionPlans',
              articles: [
                {
                  id: 1,
                  title: 'subscriptionPlans',
                  text: [
                    'includes',
                    'projects3Month',
                    'ownLayouts',
                    'savingLayout',
                    'videoFly3',
                    'tours3DMonth3',
                    'vrMode',
                    'videoFly3',
                    'featuresStartPlan',
                    'projects5Month',
                    'watermarksRemoval',
                    'kitchenConstructor',
                    'workingWithPrimitives',
                    'furnitureResizing',
                    'increasedLimits',
                    'projectsVideoFly3DTours',
                    'addMoreContact',
                    'premiumFeatures',
                    'projects20Month',
                    'uploadModelsTextures30',
                    'uploadMaterials30',
                    'increasedLimits',
                    'projects50Fly3DTours',
                    'designFeatures',
                    'projects15Month',
                    'uploadModelsTextures50',
                    'uploadMaterials50',
                    'propLi6',
                    'propLi5',
                    'prioritySupport',
                    'propLimits1',
                    'propDevFeatures',
                    'projects100Month',
                    'uploadModelsTextures100',
                    'uploadMaterials100',
                    'showingModelsWebsite2',
                    'propLi6',
                    'integrate3DToursWeb',
                    'prioritySupport',
                    'projects100video200',
                  ],
                },
                {
                  id: 2,
                  title: 'subManagement',
                  text: ['subManagementT1', 'subManagementT2'],
                },
              ],
            },
          ],
        },
        {
          id: 2,
          icon: `${
            useRuntimeConfig().public.vueAppStaticUrl
          }/images/svg/home.svg`,
          title: 'createProject',
          linkName: 'creating-project',
          subtitle: 'createProjectDesc',
          articlesTitle: [
            {
              id: 1,
              title: 'creatingLayout',
              articles: [
                {
                  id: 1,
                  title: 'howToSwitch',
                  text: [
                    'firstCreateRoomLayout',
                    'toDoThis',
                    'editLayout',
                  ],
                },
                {id: 2, title: 'menu', text: []},
                {
                  id: 3,
                  title: 'creatingRoomLayout',
                  text: [
                    'startWorking',
                    'upldBackRef',
                    'upldJpgPng',
                    'scalBackRef',
                    'scaleLayoutBackground',
                    'creatLayPrecDraw',
                    'createRoom',
                    'useRulerGuidesEtc',
                    'stepByStep',
                    'innerOutline',
                    'outerOutlines',
                    'deleteCreatedOutlines',
                    'setTheCeilingHeight',
                    'viewNavigate',
                    'repositionLayout',
                    'rotateMouseZoom',
                    'holdDownMouseMove',
                    'createDoorwaysMode',
                    'areaWantDoor',
                    'doorCreatedAutomatically',
                    'doorwayOptions',
                    'deleteCreatedDoorsInstruction',
                    'windowOpeningsMode',
                    'selectCreateWindOpenMode',
                    'windowCreateAutomatic',
                    'widthHeightOpening',
                    'deleteCreatedWindows',
                    'Preview3DMode',
                    'beforeYouStartWorkingInterior',
                    'return2DIcon',
                  ],
                },
                {
                  id: 4,
                  title: 'saveRoomLayoutWithoutNumber',
                  text: [
                    'saveRoomLayoutWithoutNumberT1',
                    'myProjects',
                    'twoSavingOptions',
                    'saveProjectModal',
                    'newProjectSaveProjectModal',
                  ],
                },
                {
                  id: 5,
                  title: 'savingEditingExistingLayout',
                  text: [
                    'myProjectsand',
                    'saveRoomLayoutWithoutNumberT1',
                  ],
                },
              ],
            },
            {
              id: 2,
              title: 'interiorDesign',
              articles: [
                {
                  id: 1,
                  title: 'switchInteriorDesmode',
                  text: [
                    'interiorDesignMode',
                    'selectingCreateDesign',
                  ],
                },
              ],
            },
            {
              id: 3,
              title: 'menu',
              articles: [
                {
                  id: 1,
                  title: 'cameraModeSettings',
                  text: [
                    'cameraModeSettingsT1',
                    'howToCreateContentInstr',
                    'cameraModeSettingsT2',
                    'cameraModeSettingsT3',
                    'cameraModeSettingsT4',
                    'cameraModeSettingsT5',
                    'cameraModeSettingsT6',
                    'cameraModeSettingsT7',
                    'cameraModeSettingsT8',
                  ],
                },
                {
                  id: 2,
                  title: 'settingsGeneralEtc',
                  text: [
                    'settingsGeneralEtcT1',
                    'settingsGeneralEtcEntry',
                    'oneGeneralSetting',
                    'functionsAvailableGeneralSettings',
                    'autosaveSaveDesignRealTime',
                    'languageDreamFlatInterface',
                    'tvSettings',
                    'graphicsSettings',
                    'functionsAvailableFromGraphicsSettings',
                    'basicSettings',
                    'defaultScreen',
                    'quatitySettings',
                    'advancedSettings',
                    'smoothingWillMakeTheEdges',
                    'adjustPostProcessingSettings',
                    'lightningSettings',
                    'lightingSettings',
                    'generalSettingsThree',
                    'selectEitherDayNight',
                    'diffusedLightIntensity',
                    'diffusedLightTemperature',
                    'ambientLight',
                    'panoramicViewOutside',
                    'windowViewCustomise',
                    'panoramaLightIntensity',
                    'rotationAnglePanoramicView',
                    'sunlight',
                    'sunlightIntensity',
                    'sunlightTemperature',
                    'solarAngle',
                    'fourSolarAltitude',
                    'threePostProcessingSettings',
                    'PostProcessingSettingsDesc',
                  ],
                },
                {
                  id: 3,
                  title: 'helpControl',
                  text: ['configureTheControl'],
                },
                {id: 4, title: 'notes', text: ['textBoxAppear']},
                {id: 5, title: 'roulette', text: ['rouletteDesc']},
                {
                  id: 6,
                  title: 'movingObjectsThroughWalls',
                  text: ['movingObjectsThroughWallsInstructions'],
                },
              ],
            },
            {
              id: 4,
              title: 'lObjectBr',
              articles: [
                {
                  id: 1,
                  title: 'leftBrowserSections',
                  text: ['offersDreamFlatTools'],
                },
                {
                  id: 2,
                  title: 'favorites',
                  text: [
                    'quicklyAccess',
                    'addingModel',
                    'addingModelFavourites',
                    'createFolder',
                    'folderCreatedEarlier',
                    'folderCreatedEarlier',
                    'addingFromScene',
                    'addingFavoritesModel',
                    'addingFavoritesModelInstructions',
                    'addingFavoritesModelInstructions2',
                    'selections',
                    'useUrProjects',
                  ],
                },
                {id: 3, title: 'search', text: ['enterKeywords']},
                {
                  id: 4,
                  title: 'finishingWord',
                  text: [
                    'useAnyFinishYourProject',
                    'sceneMaterialFunctions',
                    'changeMaterialPosition',
                    'triplanarTextureMapping',
                  ],
                },
                {
                  id: 5,
                  title: 'modelsAndTheirFunctions',
                  text: [
                    'presetmodels',
                    'movingRotating',
                    'addInteriorObject',
                    'movedLeftRightUpDown',
                    'aroundVerticalAxis',
                    'randomCopy',
                    'copyPasteObjct',
                    'copyAxis',
                    'copyAxisDetail',
                    'grpngRttngObjectGroup',
                    'ctrl2MoreObjects',
                    'options2RttngGrpd',
                    'rotateGroupedObjects',
                    'rotatearoundObjct',
                    'autoRotate',
                    'modelFunction',
                    'deletingObjects',
                    'deleteAnObject',
                  ],
                },
                {
                  id: 6,
                  title: 'furnitDecorBathEquipOther',
                  text: ['modelDragScene', 'generalOptionsModels'],
                },
                {
                  id: 7,
                  title: 'decorHeadWithoutNumber',
                  text: ['decorHeadDesc', 'decorDesc'],
                },
                {
                  id: 8,
                  title: 'lighting',
                  text: [
                    'lightingDreamFlat',
                    'freeLightSources',
                    'installLightSources',
                    'dragAnySource',
                    'generalOptionsLight',
                    'lightOptions',
                    'lightOptions1',
                    'lightOptions3',
                    'lightOptionsMetric',
                    'activityMode',
                    'turnOffLight',
                    'litArea',
                    'colorTemp',
                    'moveSlider',
                    'adjustLightColor',
                    'changeLightTemp',
                    'lightSource',
                    'iesProfile',
                    'selectShapeLight',
                    'shapeIntensity',
                    'lightSourceRadius',
                    'lightSourceLength',
                    'limelight',
                    'limelightIsConeShapedLightSource',
                    'lightDistribution',
                    'rectangularLight',
                    'availableInTheLightSource',
                    'additionallyAdjustTheLengthRectangularLight',
                    'spotLight',
                    'spotLightIsLight',
                    'fixturesLampsSpotLightSystems',
                    'spotLightSystemsInYourProject',
                    'lightingObjectToYourScene',
                    'availableForLightingObjects',
                    'activityModeChooseWhenLightBeOn',
                    'turnOffTheLightObject',
                    'chooseDisplayLitArea',
                  ],
                },
                {
                  id: 9,
                  title: 'kitchen',
                  text: [
                    'preMadeKitchens',
                    'preDesignedKitchens',
                    'designedKitchensAvailableInTheLibrary',
                    'modularKitchens',
                    'canCreateKitchenUsingKitchenModules',
                    'fridgeEtcAreAvailable',
                    'whereYouCanConfigureTheObjectParameters',
                    'generalOptionsForKitchenModules',
                    'theyCanBeMovedRotated',
                    'autoRotationKitchenDefault',
                    'alignmentWillAllowAutomaticallyPlace',
                    'changingTheObjectDimensions',
                    'bottomModules',
                    'adjustTheColourAndTypeFrontSurface',
                    'customizeTheProfileMaterial',
                    'customizeThePlinthMaterial',
                    'selectCountertopMaterial',
                    'selectTheMaterial',
                    'DisplayBoxToHideCountertop',
                    'overhangCountertop',
                    'selectYourWashBasin',
                    'selectCookingSurface',
                    'tallUnit',
                    'adjustTheColourAndTypeFrontSurface',
                    'customizeThePlinthMaterialAssign',
                    'fridge',
                    'adjustTheColourAndTypeFrontSurface',
                    'customizeThePlinthMaterialAssign',
                    'upperWallModules',
                    'changeHeightUpperWall',
                    'selectMaterialColorUpperWall',
                    'lowerWallModules',
                    'changeHeightLowerWall',
                    'selectMaterialColorLowerWall',
                  ],
                },
                {
                  id: 10,
                  title: 'primitives',
                  text: [
                    'primitivesSetsGeometricShapes',
                    'usePrimitive',
                    'generalOptionsSceneModels',
                    'changingDimensions',
                    'assignMaterialPrimitive',
                    'primitiveType',
                    'humanFiguresAvailablePrimitives',
                    'seeTutorialUsingPrimitives',
                  ],
                },
                {
                  id: 11,
                  title: 'customObjectsWithoutNumber',
                  text: [
                    'preMadeKitchens',
                    'customModel',
                    'addingModel',
                    'instuctionAddingModel',
                    'importModelDialogBoxInstructions',
                    'uploadedModelAppearCustomObjects',
                    'watchVideoHowAddOwnModel',
                    'modifyingCustomModelAddedScene',
                    'optionsSceneObjectsAreAvailableCustomModels',
                    'additionalFunctionsAvailableModels',
                    'autoRotateThisModelFunction',
                    'customMaterial',
                    'addMaterial',
                    'addedToLibrary',
                    'addedToLibraryInstr',
                    'addedToLibraryInstr2',
                    'addedToLibraryInstr3',
                    'addedToLibraryInstrVideo',
                    'modifyingCustomMaterial',
                    'sceneMaterialsAvailableForCustomMaterials',
                  ],
                },
                {
                  id: 12,
                  title: 'doorsAndWindows',
                  text: [
                    'modifyDoor',
                    'doorsAndWindowsT1',
                    'followingParametersDoors',
                    'DoorAndFrameDisplay',
                    'directionDoorOpeningHandlePosition',
                    'offset',
                    'useElementsAdjustColourMaterial',
                    'useElementsAdjustColourMaterial',
                    'windows',
                    'modifyWindow',
                    'setFollowingParametersWindows',
                    'displayedHandles',
                    'numberOpeningSections',
                    'offset',
                    'useElementsAdjustColourMaterial2',
                    'moreAboutWindows',
                  ],
                },
              ],
            },
            {
              id: 5,
              title: 'RObjectBr',
              articles: [
                {
                  id: 1,
                  title: 'workingWithObjects',
                  text: [
                    'workingWithObjectsT1',
                    'workingWithObjectsT2',
                    'workingWithObjectsT3',
                    'workingWithObjectsT4',
                    'workingWithObjectsT5',
                    'workingWithObjectsT6',
                    'workingWithObjectsT7',
                    'workingWithObjectsT8',
                    'workingWithObjectsT9',
                    'workingWithObjectsT10',
                    'workingWithObjectsT11',
                    'workingWithObjectsT12',
                    'workingWithObjectsT13',
                  ],
                },
              ],
            },
            {
              id: 6,
              title: 'SavingAndReopeningAProject',
              articles: [
                {
                  id: 1,
                  title: 'savingDes',
                  text: ['saveProjectInstruction'],
                },
                {
                  id: 2,
                  title: 'replacingDesignVersion',
                  text: ['switchDesignMode'],
                },
                {
                  id: 3,
                  title: 'reOpeningDesign',
                  text: ['continueWorkingSavedDesign'],
                },
                {
                  id: 4,
                  title: 'publicationPublicDomain',
                  text: ['publicationPublicDomainT1'],
                },
              ],
            },
          ],
        },
        {
          id: 3,
          icon: `${
            useRuntimeConfig().public.vueAppStaticUrl
          }/images/svg/camera.svg`,
          title: 'contentCreationAndProjectDemonstration',
          linkName: 'create-content-and-project-demonstration',
          subtitle: 'contentCreationAndProjectDemonstrationDesc',
          articlesTitle: [
            {
              id: 1,
              title: 'helpCenter_contentCreation',
              articles: [
                {
                  id: 1,
                  title: 'renderers',
                  text: [
                    'photoModeSettings',
                    'photoModeSettingsInstr',
                    'photoModeSettingsOne',
                    'photoModeSettingsSave',
                    'photoModeSettingsResolution',
                    'photoModeSettingsFormat',
                    'cameraView',
                    'sensorWidth',
                    'sensorHeight',
                    'focusDistance',
                    'diaphragm',
                    'aperture',
                    'focusOption',
                    'focusOptionNo',
                    'focusOptionManual',
                    'focusOptionObject',
                    'howToMakeRender',
                    'howToMakeRenderInstr',
                    'howToMakeRenderInstr2',
                  ],
                },
                {
                  id: 2,
                  title: 'videoFlyThroughs',
                  text: [
                    'videoModeSettings',
                    'videoFlyThroughsT1',
                    'videoFlyThroughsT2',
                    'videoModeSettingsOne',
                    'videoModeSettingsFolder',
                    'videoModeSettingsResolution',
                    'videoModeSettingsFrameRate',
                    'cameraView',
                    'sensorWidth',
                    'sensorHeight',
                    'focusDistance',
                    'diaphragm',
                    'aperture',
                    'focusOption',
                    'focusOptionNo',
                    'focusOptionManual',
                    'focusOptionObject',
                    'howToMakeVideoFly',
                    'howToMakeVideoFlyInstr',
                    'howToMakeVideoFlySave',
                  ],
                },
                {
                  id: 3,
                  title: 'tours3DWeb',
                  text: ['howToMakeTour', 'watch3dTour'],
                },
                {
                  id: 4,
                  title: 'interactiveTours',
                  text: [
                    'dreamFlatInteractiveTour',
                    'dreamFlatInteractiveTourHideInterface',
                  ],
                },
                {id: 5, title: 'vr', text: ['dreamFlatVrMode']},
                {
                  id: 6,
                  title: 'helpСenter_createСontent_render_equipment',
                  text: []
                },
              ],
            },
          ],
        },
      ],
    } as {
      galleryList: Array<{
        name: string;
        desc: string[];
        images: string[];
        video: string[][];
        videoMobile: string[][];
        tour: string;
        poster: any;
      }>;
      galleryRealtList: Array<{
        name: string;
        desc: string[];
        images: string[];
        video: string[][];
        videoMobile: string[][];
        tour: string;
        poster: {
          videoSrc: string;
          value: string;
        }[];
      }>;
      listArticles: Array<{
        id: number;
        icon: string;
        title: string;
        linkName: string;
        subtitle: string;
        articlesTitle: {
          id: number;
          title: string;
          articles: {
            id: number;
            title: string;
            text: string[];
          }[];
        }[];
      }>;
    }),
  actions: {},
  getters: {
    getTariffsCardList() {
      return [
        {
          id: 1,
          color: '#839AAF',
          info: {
            name: 'START',
            price: {
              title: 'free',
              titleRu: 'Бесплатно',
            },
            list: [{title: 'designSaveUnavailable'},{title: 'layoutSaveThree'},{title: 'modelLibrary'}, {title: 'videoFly3'}, {title: 'tours3DMonth3'}, {title: 'vrMode'}],
            button: {
              text: 'download',
              callback: () => {
                navigateTo('/en');
              },
            }
          }
        },
        {
          id: 2,
          color: '#2491E7',
          support: true,
          info: {
            name: 'PREMIUM',
            price: {
              title: 'dollars9',
              titleRu: '490 ₽',
              subtitle: 'month',
            },
            list: [{title: 'featuresStartPlan'}, {title: 'designSaveAvailable'}, {title: 'layoutSaveFive'}, {title: 'watermarksRemoval'}, {title: 'kitchenConstructor'}, {title: 'workingWithPrimitives'}, {title: 'furnitureResizing'}, {
              title: 'increasedLimits',
              subtitle: 'projectsVideoFly3DTours'
            }],
            button: {
              text: 'subscribeTitle',
              callback: () => {
                navigateTo('/pay/premium');
              },
            }
          }
        },
        {
          id: 3,
          color: '#0F5185',
          support: true,
          info: {
            name: 'DESIGNER +',
            price: {
              title: 'dollars29',
              titleRu: '1 490 ₽',
              subtitle: 'month',
            },
            list: [{title: 'premiumFeatures'}, {title: 'layoutSaveTwenty'},{title: 'uploadMaterials30'}, {
              title: 'increasedLimits',
              subtitle: 'projects50Fly3DTours'
            }],
            button: {
              text: 'subscribeTitle',
              callback: () => {
                navigateTo('/pay/designer');
              },
            }
          }
        }
      ];
    },
    getTariffsCardListBusiness() {
      return [
        {
          id: 1,
          color: '#2491E7',
          support: true,
          info: {
            name: 'PROPERTY DEVELOPERS',
            price: {
              title: 'dollars290',
              titleRu: '17 500 ₽',
              subtitle: 'month',
            },
            list: [{title: 'designFeatures'}, {title: 'layoutSaveHundred'}, {title: 'uploadModelsTextures50'}, {title: 'uploadMaterials50'},
              {title: 'propLi6'}, {title: 'propLi5'}, {title: 'prioritySupport'}, {
                title: 'increasedLimits',
                subtitle: 'propLimits1'
              }],
            button: {
              text: 'subscribeTitle',
              callback: () => {
                navigateTo('/pay/property');
              },
            }
          }
        },
        {
          id: 2,
          color: '#0F5185',
          support: true,
          info: {
            name: 'ENTERPRISE',
            price: {
              title: 'dollars390',
              titleRu: '24 900 ₽',
              subtitle: 'month',
            },
            list: [{title: 'propDevFeatures'}, {title: 'layoutSaveHundred'}, {title: 'uploadModelsTextures100'}, {title: 'uploadMaterials100'}, {title: 'showingModelsWebsite2'},
              {title: 'showingModelsWebsite'}, {title: 'integrate3DToursWeb'}, {title: 'prioritySupport'}, {
                title: 'increasedLimitsForAccount',
                subtitle: 'projects100video200'
              }],
            button: {
              text: 'subscribeTitle',
              callback: () => {
                navigateTo('/pay/enterprise');
              },
            }
          }
        }
      ];
    }
  }
});
